import { ImportResult } from '~/domain/services/dicomProcessor';

export const RIGID_RESULT_LABEL = 'RIGID_REG';
export const DEFORMABLE_RESULT_LABEL = 'DEFORM_REG';

// The worker labels each registration with a timestamp; the list names it by kind instead.
export function labelResultRegistrations(
    result: Pick<ImportResult, 'registrations' | 'deformableRegistrations'>
): void {
    for (const registration of result.registrations) {
        registration.dicomParent.contentLabel = RIGID_RESULT_LABEL;
    }
    for (const registration of result.deformableRegistrations) {
        registration.contentLabel = DEFORMABLE_RESULT_LABEL;
    }
}
